import React, { useState, useEffect } from 'react';
import icon from './favicon.png';
import { Link } from 'react-router-dom';

function Navbar() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const scrollThreshold = window.innerHeight * 0.2; // 20% of the viewport height

            setIsScrolled(scrollPosition > scrollThreshold);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const closeSidebar = () => {
        setIsOpen(false);
    };

    return (
        <nav className={`bg-white shadow-lg ${isScrolled ? 'fixed top-0 left-0 w-full z-10 transition duration-400 ease-in-out' : ''}`}>
            <div className="max-w-6xl mx-auto">
                <div className="flex justify-between items-center">
                    <div className="flex items-center space-x-7">
                        <a href="/" className="flex items-center py-4 px-2">
                            <img className='w-8 mr-2' src={icon} alt="Logo" />
                            <span className="font-semibold text-gray-700 text-lg">Windify</span>
                        </a>
                    </div>
                    <div className="hidden md:flex items-center space-x-1 ml-auto">
                        <Link to={'/'} onClick={closeSidebar} className="py-2 px-2 text-gray-700 font-semibold">Home</Link>
                        <Link to={'/how'} onClick={closeSidebar} className="py-4 px-2 text-gray-700 font-semibold hover:text-blue-600 transition duration-300">How It Works</Link>
                        <Link to={'/privacy-policy'} onClick={closeSidebar} className="py-4 px-2 text-gray-700 font-semibold hover:text-blue-600 transition duration-300">Privacy Policy</Link>
                    </div>
                    <div className="md:hidden flex items-center">
                        <button className="outline-none mobile-menu-button" onClick={() => setIsOpen(!isOpen)}>
                            <svg className="w-6 h-6 text-gray-700 hover:text-blue-600" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                                <path d="M4 6h16M4 12h16M4 18h16"></path>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <div className={`fixed inset-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out md:hidden bg-gray-100 z-20`}>
                <div className="flex justify-between items-center p-4 bg-white shadow">
                    <a href="/" onClick={closeSidebar} className="flex items-center py-2 px-2">
                        <img className='w-8 mr-2' src={icon} alt="Logo" />
                        <span className="font-semibold text-gray-700 text-lg">Windify</span>
                    </a>
                    <button onClick={() => setIsOpen(false)}>
                        <svg className="w-6 h-6 text-gray-700 hover:text-blue-600" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                            <path d="M6 18L18 6M6 6l12 12"></path>
                        </svg>
                    </button>
                </div>
                <div className="flex flex-col items-start space-y-2 p-4">
                    <Link to={'/'} onClick={closeSidebar} className="py-2 px-2 text-gray-700 font-semibold">Home</Link>
                    <Link to={'/how'} onClick={closeSidebar} className="py-4 px-2 text-gray-700 font-semibold hover:text-blue-600 transition duration-300">How It Works</Link>
                    <Link to={'/privacy-policy'} onClick={closeSidebar} className="py-4 px-2 text-gray-700 font-semibold hover:text-blue-600 transition duration-300">Privacy Policy</Link>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
